import React from "react";

/**
 * Apple-style statistics card, used to display a value with icon.
 */
export default function AppleStatCard({ title, subtitle, value, valueColor, icon }) {
  return (
    <div className="rounded-lg bg-bg-card border border-border-default flex flex-col p-spacing-2 min-w-40 min-h-24 relative transition-all duration-200">
      <div className="flex justify-between items-center mb-spacing-1">
        <span className="text-primary text-dls-body font-bold">{title}</span>
        {icon}
      </div>
      {subtitle && <div className="text-secondary text-dls-small mb-spacing-2">{subtitle}</div>}
      <div
        className="mb-spacing-1 text-dls-h2 font-bold"
        style={{
          color: valueColor,
        }}
      >
        {value}
      </div>
    </div>
  );
}
